import React, { memo } from 'react';
import { withNativeProps } from '../../../utils/native-props';
export var WeixinCircleIcon = /*#__PURE__*/memo(function (props) {
  return withNativeProps(props, /*#__PURE__*/React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "26",
    cy: "26",
    r: "24",
    fill: "#3ABE51"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.486 32.0938C36.0237 34.8444 33.6023 37.0074 30.6678 38.1368L24.6248 32.0938H37.486",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.0938 14.5139C34.8444 15.9762 37.0074 18.3977 38.1368 21.3322L32.0938 27.3752V14.5139",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.1863 13.5684C23.3923 13.1989 24.6729 13 26 13C27.8804 13 29.6675 13.3992 31.2813 14.1175V22.6634L22.1863 13.5684",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.4317 22.1864C38.8012 23.3924 39.0001 24.6731 39.0001 26.0002C39.0001 27.8805 38.6008 29.6677 37.8825 31.2814H29.3367L38.4317 22.1864",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7188 37.8824C22.3325 38.6008 24.1196 39 26 39C27.3271 39 28.6077 38.8011 29.8138 38.4316L20.7188 29.3366V37.8824",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9063 37.4861C17.1557 36.0238 14.9927 33.6024 13.8633 30.6678L19.9063 24.6248V37.4861",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5684 29.8138C13.1989 28.6077 13 27.3271 13 26C13 24.1196 13.3992 22.3325 14.1175 20.7188L22.6634 20.7188L13.5684 29.8138",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5137 19.9063C15.976 17.1557 18.3974 14.9927 21.3319 13.8633L27.375 19.9063H14.5137Z",
    fill: "white"
  })));
});